import axiosInstance from './axiosInstance';

export default {
  create: (taskDefinition) => {
    return axiosInstance.post('/tasks', {
      definition: taskDefinition
    });
  },
  update: (taskId, payload) => {
    const allowedProperties = ['definition', 'completed_at'];
    const data = {};

    allowedProperties.forEach((prop) => {
      if (Object.prototype.hasOwnProperty.call(payload, prop)) {
        data[prop] = payload[prop];
      }
    });

    return axiosInstance.put(`/tasks/${taskId}`, data);
  },
  list: () => {
    return axiosInstance.get('/users/me/tasks');
  },
  delete: (taskId) => {
    return axiosInstance.delete(`/tasks/${taskId}`);
  }
};
